import React from "react";
import { Row, Col, Card, Typography, Space } from "antd";
import { InstagramOutlined, FacebookOutlined } from "@ant-design/icons";
import founder_one from "../assets/images/founder_one.png";
import founder_two from "../assets/images/founder_two.png";
import { useBreakpoints } from "./ResponsiveBreakPoints";

const { Title, Text } = Typography;

const Leadership = () => {
    const { isSuperLarge } = useBreakpoints();

    const leaders = [
        {
            name: "Rakesh Vakil",
            title: "Founder",
            description:
                "With over 36 years in real estate, my journey began in 1990 alongside Ahmedabad’s transformation into a thriving urban landscape. Over the decades, I have built trusted relationships across the ecosystem developers, clients, and partners guided by integrity, insight, and long-term vision. My experience allows me to anticipate market shifts, mentor future leaders, and help people make confident, value-driven real estate decisions. I continue to focus on shaping opportunities that stand the test of time in one of India’s most dynamic property markets.",
            image: founder_one,
        },
        {
            name: "Harsh Vakil",
            title: "Director",
            description:
                "He brings a strong foundation in construction, marketing, and execution, shaped by hands-on experience and an uncompromising focus on quality. Alongside this, he leads a successful decoration venture at Aarya Grand Hotel & Resort, Sola while playing a key role as a second generation entrepreneur in the family’s real estate firm, balancing both ventures with clarity and purpose. Driven by innovation and trust, he focuses on building enduring spaces, experiences, and long-term relationships.",
            image: founder_two,
        },
    ];

    return (
        <div id="leadership" style={{ padding: "80px 0", background: "#fdfdfd" }}>
            <Row justify="center">
                <Col
                    xs={22}
                    sm={22}
                    md={22}
                    lg={18}
                    xl={20}
                    xxl={16}
                    style={{ maxWidth: isSuperLarge ? "50%" : "" }}
                >
                    <div style={{ textAlign: "center", marginBottom: "60px" }}>
                        <Title level={2} style={{ color: "#1c3988", fontSize: "42px", fontWeight: 700, marginBottom: "16px" }}>
                            About Us
                        </Title>
                        <Text style={{ fontSize: "18px", color: "#666", display: "block", maxWidth: "800px", margin: "0 auto", lineHeight: "1.6" }}>
                            <strong>Shree Vastu Management and Developers</strong> is a professional real estate firm founded in <strong>1990</strong> by Mr. Rakesh Vakil. With over <strong>36 years of continuous operations</strong>, the company has established a <strong>strong presence in Ahmedabad</strong>, built on long-standing relationships with leading developers and a reputation for <strong>transparency and integrity</strong>.
                            <br /><br />
                            Under Mr. Vakil’s leadership, the firm delivers <strong>structured, client-centric advisory</strong> across residential and commercial real estate, aligning every transaction with <strong>long-term objectives</strong>. A robust developer network enables <strong>early access to projects</strong>, deeper market insights, and informed recommendations for buyers, investors, and lessors.
                            <br /><br />
                            Driven by <strong>professionalism, market knowledge, and process-led execution</strong>, Shree Vastu Management and Developers continues to evolve as a <strong>trusted real estate partner</strong>, creating consistent and lasting value for its clients.
                        </Text>
                    </div>

                    <Row gutter={[32, 32]} style={{ display: "flex", alignItems: "stretch" }}>
                        {leaders.map((leader, index) => (
                            <Col xs={24} lg={12} key={index} style={{ display: "flex" }}>
                                <Card
                                    hoverable
                                    style={{
                                        borderRadius: "20px",
                                        overflow: "hidden",
                                        border: "none",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column"
                                    }}
                                    bodyStyle={{ padding: "30px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}
                                >
                                    <Row gutter={[24, 24]} align="middle">
                                        <Col xs={24} sm={9}>
                                            <div style={{ borderRadius: "16px", overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.1)" }}>
                                                <img
                                                    src={leader.image}
                                                    alt={leader.name}
                                                    style={{
                                                        width: "100%",
                                                        height: "220px",
                                                        display: "block",
                                                        objectFit: "cover",
                                                        objectPosition: "top"
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={15}>
                                            <div style={{ padding: "10px 0" }}>
                                                <Typography.Title level={3} style={{ margin: 0, color: "#1c3988", fontWeight: 700 }}>
                                                    {leader.name}
                                                </Typography.Title>
                                                <Typography.Text strong style={{ color: "#2a4fac", fontSize: "16px", display: "block", marginBottom: "12px" }}>
                                                    {leader.title}
                                                </Typography.Text>
                                                <Typography.Paragraph style={{ color: "#555", fontSize: "15px", lineHeight: "1.6", marginBottom: "20px" }}>
                                                    {leader.description}
                                                </Typography.Paragraph>
                                                {/* <Space size="large">
                                                    <InstagramOutlined style={{ fontSize: "24px", color: "#E1306C", cursor: "pointer" }} />
                                                    <FacebookOutlined style={{ fontSize: "24px", color: "#4267B2", cursor: "pointer" }} />
                                                </Space> */}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default Leadership;
